import React, { createContext, useContext, useState } from 'react';

const PopoverContext = createContext();

export const PopoverProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);

  const togglePopover = (value) => {
    setVisible(value)
    //setVisible((prev) => !prev);
  };

  const hidePopover = () => {
    setVisible(false);
  };

  const showPopover = () => {
    setVisible(true);
  };

  return (
    <PopoverContext.Provider value={{ visible, togglePopover, hidePopover, showPopover }}>
      {children}
    </PopoverContext.Provider>
  );
};

export const useDropdownMenu = () => {
  return useContext(PopoverContext);
};